import { Component, OnInit } from '@angular/core';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import * as _ from "lodash";

import {
  ApexAxisChartSeries, ApexGrid, ApexChart,
  ApexXAxis, ApexYAxis, ApexMarkers,
  ApexStroke, ApexLegend, ApexResponsive,
  ApexTooltip, ApexFill, ApexDataLabels,
  ApexPlotOptions, ApexTitleSubtitle, ChartComponent,
  ApexNonAxisChartSeries, ApexAnnotations
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  fill: ApexFill;
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  colors: string[];
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: any; //ApexXAxis;
  annotations: ApexAnnotations;
  stroke: ApexStroke;
  grid: ApexGrid;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
};

export type barChatOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  colors: string[];
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
};
@Component({
  selector: 'app-payment-dashboard',
  templateUrl: './payment-dashboard.component.html',
  styleUrls: ['./payment-dashboard.component.scss']
})
export class PaymentDashboardComponent implements OnInit {
  cardData: any = {};
  lastUpdatedDate: any;
  public barChatOptions: Partial<barChatOptions>;
  public donutOptions: Partial<ChartOptions>;
  public areaChartOptions: Partial<barChatOptions>;

  constructor(
    private LookupServices: LookupDataServiceService,

  ) { }

  ngOnInit(): void {
    this.getDashData();
  }

  getDashData() {
    this.LookupServices.GetBalancePayment().subscribe((res) => {
      res[0].forEach(value => {
        switch (value.configKey) {
          case 'TotalBalance':
            this.cardData.TotalBalance = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            this.cardData.BilableCustomerCount = value.customerCount.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
            break;
          case 'Debit1st':
            this.cardData.Debit1st = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');;
            break;
          case 'Debit15th':
            this.cardData.Debit15th = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');;
            break;
          case 'Debit25th':
            this.cardData.Debit25th = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');;
            break;
          case 'EFT':
            this.cardData.EFT = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');;
            break;
          case 'CollectionWiseBalance':
            this.cardData.Collection = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');;
            break;
          case 'ResellerWiseBalance':
            this.cardData.Reseller = 'R ' + value.configValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');;
            break;
        }
      });
      let treeData = [], treeDataPass = [];
      treeData = res[3];
      if (treeData.length != 0) {
        treeData.forEach((i) => {
          let data = {
            x: i.children[0].name,
            y: i.children[0].value,
            z: i.children[0].balance
          };
          treeDataPass.push(data)

        });
        treeDataPass = _.orderBy(treeDataPass, ["y"], ["desc"]);
      }
      this.donutChart(res[1]);
      this.barChart(res[2]);
      this.TreeChart(treeDataPass);
      this.lastUpdatedDate = res[4].lastChangeTs;
    });
  }

  barChart(data) {
    const count = data.map((v) => v.balance);
    const type = data.map((v) => v.id);

    this.barChatOptions = {
      series: [
        {
          data: count
        }
      ],
      chart: {
        type: "bar",
        height: 500,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          barHeight: "100%",
          columnWidth: "95%",
          distributed: true,
          horizontal: false,
          dataLabels: {
            position: "bottom"
          }
        }
      },
      legend: {
        show: false
      },
      colors: [
        "#66ADCF", "#608ACC", "#606ACC", "#7660CC",
        "#9660CC", "#B760CC", "#CC60C0", "#CC60A0", "#CC5F80",
        "#CC6261", "#CC8160", "#CCA15F", "#CCC25F", "#B6CC5F",
        "#99CE65", "#75CC5F", "#60CC6D", "#5FCC8C", "#5FCCAD", "#5FCACB",
        "#76A1E2", "#7681E3"
      ],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: false
      },
      xaxis: {
        categories: type,
        labels: {
          show: true,
          rotate: -90,
          rotateAlways: false,
          hideOverlappingLabels: false,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
        },
      },
      yaxis: {
        labels: {
          show: true
        },
        title: {
          text: 'Balance',
          style: {
            fontSize: '16px'
          }
        }
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          debugger
          return '<div class="arrow_box" style="padding:7px;background:' + w.globals.colors[dataPointIndex] + ';font-family:Arial, sans-serif;font-size:12px;">' +
            '<span style="color:white;">' + w.globals.labels[seriesIndex] + ':' + '&nbsp;&nbsp;' + '<span style="font-weight:600;">' + 'R ' + series[0][dataPointIndex]?.toLocaleString("en-ZA") + '</span>' + '</span>' +
            '</div>'
        }
      },
    };
  }

  donutChart(data) {
    const count = data.map((v) => v.configValue);
    const type = data.map((v) => v.description);

    this.donutOptions = {
      series: count,
      labels: type,
      chart: {
        height: 400,
        type: "donut"
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          debugger
          return '<div class="arrow_box" style="padding:7px;background:' + w.config.colors[seriesIndex] + ';font-family:Arial, sans-serif;font-size:12px;">' +
            '<span style="color:white;">' + w.config.labels[seriesIndex] + ':' + '&nbsp;&nbsp;' + '<span style="font-weight:600;">' + 'R ' + series[seriesIndex]?.toLocaleString("en-ZA") + '</span>' + '</span>' +
            '</div>'
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          fontFamily: "Helvetica, Arial, sans-serif",
          colors: ["#484848", "#484848", "#484848"],
        },
        background: {
          enabled: true,
          borderWidth: 1,
          borderColor: '#484848',
          foreColor: '#fff',
        }
      },
      legend: {
        show: true,
        position: "right",
        fontSize: "15",
        itemMargin: {
          vertical: 7,
          horizontal: 7
        }
      },
      colors: ["#16A085", "#2471A3", "#007C00", "#CB4335", "#8E44AD", "#34495E",
        "#115044", "#1C085B", "#E67E22", "orange", "#E52B50", "#FFBF00",
        "#999999", "#9966CC", "#7FFFD4", "#007FFF", "#8A2BE2",
        "#964B00", "#800020", "#7FFF00", "#FF00FF", "#A7FC00"
      ],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: false
              },
              value: {
                fontSize: "15",
                fontWeight: 600,
                formatter: function (w) {
                  const value = parseFloat(w)
                  return 'R ' + value?.toLocaleString("en-ZA");
                },
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    };
  }

  TreeChart(data) {
    const balance = data.map((v) => v.z);
    const count = data.map((v) => v.y);
    const type = data.map((v) => v.x);

    this.areaChartOptions = {
      series: [
        {
          data: count
        }
      ],
      chart: {
        type: "bar",
        height: 500,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          barHeight: "100%",
          columnWidth: "95%",
          distributed: true,
          horizontal: false,
          dataLabels: {
            position: "top"
          }
        }
      },
      legend: {
        show: false
      },
      colors: [
        "#67B7DC", "#6771DC", "#A367DC",
        "#DC67CE", "#DC6788", "#DC8C67", "#DCD267"
      ],
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20,
        formatter: function (val, opts) {
          return val?.toLocaleString("en-ZA");
        }
      },
      stroke: {
        show: false
      },
      xaxis: {
        categories: type,
        labels: {
          show: true,
          rotate: -90,
          rotateAlways: false,
          hideOverlappingLabels: false,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
        },
      },
      yaxis: {
        labels: {
          show: true
        },
      },
      tooltip: {
        marker: {
          show: true
        },
        shared: true,
        intersect: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          debugger
          return '<div class="arrow_box px-3 pb-3" style="width:200px; font-size: 15px;background-color:' + w.config.colors[dataPointIndex] + '">' +
            '<span style="font-weight: bold; display: inline-block; margin-top: 0.5em;color:#fff;">' + w.globals.labels[dataPointIndex] + '</span>' +
            '<hr style="margin: 5px 0px; background-color: #fff; width: 100%" />' +
            '<div style="text-align: left; margin-right:7px">' +
            '<span style="color:#fff;">' + 'Count' + ' : </span>' +
            '<span style="font-weight: bold;color:#fff;">' + series[0][dataPointIndex].toLocaleString('en-ZA') + '</span><br>' +
            '<span style="color:#fff;">' + 'Balance' + ' : </span>' +
            '<span style="font-weight: bold;color:#fff;">' + 'R ' + balance[dataPointIndex].toLocaleString('en-ZA') + '</span>' +
            '</div>' +
            '</div>'
        }
      },
    };
  }

}
